import { UserManager, UserManagerSettings, WebStorageStateStore, Log } from "oidc-client-ts";
import { PROTOCOL_HTTP, HOST, API_VERSION } from "../../env";

// Set the logger to console
// Log.setLogger(console);

// Set the logging level to DEBUG (to see detailed logs)
// Log.setLevel(Log.DEBUG);

export const oidcConfig: UserManagerSettings = {
  authority: `${PROTOCOL_HTTP}://${HOST}/${API_VERSION}`, // Spring auth server
  client_id: "front-static",
  redirect_uri: `${PROTOCOL_HTTP}://${HOST}/auth-callback`,
  post_logout_redirect_uri: `${PROTOCOL_HTTP}://${HOST}`,
  response_type: "code",
  scope: "openid profile email",
  automaticSilentRenew: false,
  silent_redirect_uri: `${PROTOCOL_HTTP}://${HOST}/silent-renew.html`,
  validateSubOnSilentRenew: false,
  loadUserInfo: false,
  userStore: new WebStorageStateStore({ store: window.localStorage })
};

export const userManager = new UserManager(oidcConfig);